var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationContained(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1829 7.04158C16.3079 3.19159 12.9496 1.45825 9.99959 1.45825C9.99959 1.45825 9.99959 1.45825 9.99126 1.45825C7.04959 1.45825 3.68292 3.18325 2.80792 7.03325C1.83292 11.3333 4.46626 14.9749 6.84959 17.2666C7.73292 18.1166 8.86626 18.5416 9.99959 18.5416C11.1329 18.5416 12.2663 18.1166 13.1413 17.2666C15.5246 14.9749 18.1579 11.3416 17.1829 7.04158Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.2166C11.4497 11.2166 12.625 10.0413 12.625 8.59155C12.625 7.14181 11.4497 5.96655 10 5.96655C8.55025 5.96655 7.375 7.14181 7.375 8.59155C7.375 10.0413 8.55025 11.2166 10 11.2166Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationContained);
export default __webpack_public_path__ + "static/media/location-contained.870e9c5ac082faac1ea12f500dcf5079.svg";
export { ForwardRef as ReactComponent };